export const AddOutfitReducer = (state, action) => {
	switch (action.type) {
		case "set_position":
			return {
				...state,
				position: action.position,
			};

		case "set_outfitName":
			return {
				...state,
				outfit_name: action.outfit_name,
			};

		case "add_outfit_piece":
			return {
				...state,
				outfitPieceGrid: {
					...state.outfitPieceGrid,
					[state.position]: action.item,
				},
			};

		case "change_dimension":
			return {
				...state,
				outfitDimensionGrid: {
					...state.outfitDimensionGrid,
					[state.position]: {
						...state.outfitDimensionGrid[state.position],
						[action.dimension]: action.value,
					},
				},
			};

		case "set_zoom": {
			return {
				...state,
				zoom: action.zoom,
			};
		}

		case "set_topScale": {
			return {
				...state,
				top_scale: action.top,
			};
		}

		case "set_leftScale": {
			return {
				...state,
				left_scale: action.left,
			};
		}

		case "reset_zoom": {
			return {
				...state,
				zoom: 0,
			};
		}

		case "reset_position": {
			return {
				...state,
				top_scale: 0,
				left_scale: 0,
			};
		}

		case "set_preview":
			return {
				...state,
				preview: !state.preview,
			};

		case "reset_size":
			return {
				...state,
				outfitDimensionGrid: {
					...state.outfitDimensionGrid,
					[state.position]: {
						...state.outfitDimensionGrid[state.position],
						width_scale:
							state.position == 1 || state.position == 2
								? 0
								: -40,
						height_scale:
							state.position == 1 || state.position == 2
								? 0
								: -40,
					},
				},
			};

		case "reset_spacing":
			return {
				...state,
				outfitDimensionGrid: {
					...state.outfitDimensionGrid,
					[state.position]: {
						...state.outfitDimensionGrid[state.position],
						spacing_scale: 0,
					},
				},
			};

		case "reset_cords":
			return {
				...state,
				outfitDimensionGrid: {
					...state.outfitDimensionGrid,
					[state.position]: {
						...state.outfitDimensionGrid[state.position],
						top_scale: 0,
						left_scale: 0,
					},
				},
			};

		case "clear_piece":
			return {
				...state,
				outfitPieceGrid: {
					...state.outfitPieceGrid,
					[state.position]: defaultOutfitPiece,
				},
			};

		case "reset_all":
			return {
				...state,
				outfitPieceGrid: defaultOutfitPieceGrid,
				outfitDimensionGrid: defaultOutfitDimensionGrid,
			};
		case "set_dimension":
			return {
				...state,
				outfitPieceGrid: {
					...state.outfitPieceGrid,
					[action.position]: {
						...state.outfitPieceGrid[action.position],
						[`${action.dimension}Scale`]: action.value,
					},
				},
			};

		case "set_outfitPieceGrid":
			var outfitPieceGrid = {};
			var outfitDimensionGrid = {};
			if (action.outfit_pieces?.length == 0) {
				console.log("no length");
				return {
					...state,
					outfitPieceGrid: defaultOutfitPieceGrid,
					outfitDimensionGrid: defaultOutfitDimensionGrid,
				};
			} else {
				for (const piece of action.outfit_pieces) {
					outfitPieceGrid = {
						...outfitPieceGrid,
						[parseInt(piece.position)]: piece,
					};
					outfitDimensionGrid = {
						...outfitDimensionGrid,
						[parseInt(piece.position)]: {
							width_scale: piece.width_scale,
							height_scale: piece.height_scale,
							top_scale: piece.top_scale,
							left_scale: piece.left_scale,
							split_scale: piece.split_scale,
							z_index: piece.z_index,
							spacing_scale: piece.spacing_scale,
						},
					};
				}

				[...Array(9).keys()].forEach((key) => {
					// fill sections of the outfitPiece/outfitDimension grid that aren't filled by the outfit that was passed in
					let outfitPiece = outfitPieceGrid[key + 1];
					if (outfitPiece == undefined) {
						outfitPieceGrid[key + 1] = defaultOutfitPiece;
						outfitDimensionGrid[key + 1] =
							defaultOutfitDimensionGrid[key + 1];
					}
				});

				return {
					...state,
					outfitPieceGrid: outfitPieceGrid,
					outfitDimensionGrid: outfitDimensionGrid,
				};
			}

		case "reset_outfitPieceGrid": {
			return {
				...state,
				outfitPieceGrid: defaultOutfitPieceGrid,
				outfitDimensionGrid: defaultOutfitDimensionGrid,
			};
		}

		case "set_outfitProps":
			return {
				...state,
				outfit_name: action.outfit_name,
				top_scale: action.top_scale,
				left_scale: action.left_scale,
			};

		default:
			return state;
	}
};

const maxMinValues = {
	1: { maxHeight: 40, minHeight: -40, maxWidth: 15, minWidth: -15 },
	2: { maxHeight: 40, minHeight: -40, maxWidth: 15, minWidth: -15 },
	3: { maxHeight: -20, minHeight: -90, maxWidth: -40, minWidth: -80 },
	4: { maxHeight: -20, minHeight: -90, maxWidth: -40, minWidth: -80 },
	5: { maxHeight: -20, minHeight: -90, maxWidth: -40, minWidth: -80 },
	6: { maxHeight: -20, minHeight: -90, maxWidth: -40, minWidth: -80 },
	7: { maxHeight: -20, minHeight: -90, maxWidth: -40, minWidth: -80 },
	8: { maxHeight: -20, minHeight: -90, maxWidth: -40, minWidth: -80 },
	9: { maxHeight: -20, minHeight: -90, maxWidth: -40, minWidth: -80 },
};

const defaultOutfitPiece = {
	piece_id: null,
};

export const defaultOutfitDimension = {
	width_scale: -40,
	top_scale: 0,
	left_scale: 0,
	spacing_scale: 0,
	split_scale: 0,
	z_index: 0,
};

export const defaultOutfitDimensionGrid = {
	1: { ...defaultOutfitDimension, width_scale: 0 },
	2: { ...defaultOutfitDimension, width_scale: 0 },
	3: defaultOutfitDimension,
	4: defaultOutfitDimension,
	5: defaultOutfitDimension,
	6: defaultOutfitDimension,
	7: defaultOutfitDimension,
	8: defaultOutfitDimension,
	9: defaultOutfitDimension,
};

const defaultOutfitPieceGrid = {
	1: defaultOutfitPiece,
	2: defaultOutfitPiece,
	3: defaultOutfitPiece,
	4: defaultOutfitPiece,
	5: defaultOutfitPiece,
	6: defaultOutfitPiece,
	7: defaultOutfitPiece,
	8: defaultOutfitPiece,
	9: defaultOutfitPiece,
};

export const initialState = {
	position: 1,
	outfitPieceGrid: defaultOutfitPieceGrid,
	outfitDimensionGrid: defaultOutfitDimensionGrid,
	preview: false,
	outfit_name: "",
	zoom: 0,
	top_scale: 0,
	left_scale: 0,
};
